export default __webpack_public_path__ + "static/media/down.ea408412.svg";